import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import SendIcon from "@mui/icons-material/Send";

function SupportForm() {
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [supportFormInputFields, setsupportFormInputFields] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    query: "",
  });

  async function submitSupportForm(event) {
    event.preventDefault();

    if (
      supportFormInputFields.firstName &&
      supportFormInputFields.email &&
      supportFormInputFields.query
    ) {
      setLoadingScreen(true);
      await axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/api/contact-us`,
          { formValues: supportFormInputFields },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          setLoadingScreen(false);
          if (res.data.status) {
            swal({
              text: res.data.message,
              icon: "success",
            });
            setsupportFormInputFields({
              firstName: "",
              lastName: "",
              email: "",
              phoneNo: "",
              query: "",
            });
          } else {
            swal({
              text: res.data.message,
              icon: "warning",
            });
          }
        })
        .catch((err) => {
          setLoadingScreen(false);

          swal({
            text: err.response.data.errorMessage,
            icon: "error",
          });
        });
    } else {
      swal({
        text: "Add proper parameter first!",
        icon: "warning",
      });
    }
  }

  const onHandleSupportFormInputChange = (event) => {
    const { name, value } = event.target;
    setsupportFormInputFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  return (
    <Box
      mt="40px"
      sx={{ boxShadow: "2", borderRadius: "20px" }}
      ml="90px"
      mr="90px"
      backgroundColor="white"
    >
      <div>
        {loadingScreen && (
          <div
            style={{
              zIndex: "2",
              textAlign: "center",
              position: "absolute",
              marginLeft: "35%",
              marginTop: "15%",
            }}
          >
            <CircularProgress sx={{ color: "rgb(0, 104, 74)" }} />
          </div>
        )}
        <Box
          sx={{
            mt: 1,
            ml: 3,
            // width: 1100,
          }}
        >
          <form onSubmit={submitSupportForm}>
            <div style={{ padding: "20px 0 30px 0" }}>
              <Typography
                variant="h2"
                fontWeight="400"
                sx={{
                  textAlign: "center",
                  color: "rgb(0, 104, 74)",
                  fontFamily: "Poppins",
                }}
              >
                Contact Us
              </Typography>
              <Typography
                variant="h5"
                style={{
                  textAlign: "center",
                  color: "rgb(0, 30, 43)",
                  fontFamily: "Poppins",
                }}
              >
                We'd love to hear from you!
              </Typography>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ width: "55%", marginTop: "2%", marginRight: "5%" }}>
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "4%" }}
                >
                  <fieldset className="login-form input-fullwidth">
                    <label
                      htmlFor="firstName"
                      id="firstNameLabel"
                      className="login-form-label"
                    >
                      First Name <span className="required-field">*</span>
                      <div className="input-div-css-1 input-fullwidth input-div-css-2">
                        <div className="input-div-css-3">
                          <input
                            required
                            name="firstName"
                            aria-labelledby="firstNameLabel"
                            type="text"
                            className="input-custom-css input-custom-height"
                            id="firstName"
                            aria-invalid="false"
                            value={supportFormInputFields.firstName}
                            onChange={(e) => onHandleSupportFormInputChange(e)}
                          ></input>
                        </div>
                      </div>
                    </label>
                  </fieldset>
                  <fieldset className="login-form input-fullwidth">
                    <label
                      htmlFor="lastName"
                      id="lastNameLabel"
                      className="login-form-label"
                    >
                      Last Name
                      <div className="input-div-css-1 input-fullwidth input-div-css-2">
                        <div className="input-div-css-3">
                          <input
                            name="lastName"
                            aria-labelledby="lastNameLabel"
                            type="text"
                            className="input-custom-css input-custom-height"
                            id="lastName"
                            aria-invalid="false"
                            value={supportFormInputFields.lastName}
                            onChange={(e) => onHandleSupportFormInputChange(e)}
                          ></input>
                        </div>
                      </div>
                    </label>
                  </fieldset>
                </div>
                <fieldset className="login-form input-fullwidth">
                  <label
                    htmlFor="email"
                    id="emailLabel"
                    className="login-form-label"
                  >
                    Email <span className="required-field">*</span>
                    <div className="input-div-css-1 input-fullwidth input-div-css-2">
                      <div className="input-div-css-3">
                        <input
                          required
                          name="email"
                          aria-labelledby="emailLabel"
                          type="email"
                          className="input-custom-css input-custom-height"
                          id="email"
                          aria-invalid="false"
                          value={supportFormInputFields.email}
                          onChange={(e) => onHandleSupportFormInputChange(e)}
                        ></input>
                      </div>
                    </div>
                  </label>
                </fieldset>
                <fieldset className="login-form input-fullwidth">
                  <label
                    htmlFor="phoneNo"
                    id="phoneNoLabel"
                    className="login-form-label"
                  >
                    Phone Number
                    <div className="input-div-css-1 input-fullwidth input-div-css-2">
                      <div className="input-div-css-3">
                        <input
                          name="phoneNo"
                          aria-labelledby="phoneNoLabel"
                          type="tel"
                          className="input-custom-css input-custom-height"
                          id="phoneNo"
                          aria-invalid="false"
                          value={supportFormInputFields.phoneNo}
                          onChange={(e) => onHandleSupportFormInputChange(e)}
                        ></input>
                      </div>
                    </div>
                  </label>
                </fieldset>
                <fieldset className="login-form input-fullwidth">
                  <label
                    htmlFor="query"
                    id="queryLabel"
                    className="login-form-label"
                  >
                    Query <span className="required-field">*</span>
                    <div className="input-div-css-1 input-fullwidth input-div-css-2">
                      <div className="input-div-css-3">
                        <textarea
                          required
                          style={{
                            height: "100px",
                          }}
                          name="query"
                          aria-labelledby="queryLabel"
                          type="text"
                          className="input-custom-css"
                          id="query"
                          aria-invalid="false"
                          value={supportFormInputFields.query}
                          onChange={(e) => onHandleSupportFormInputChange(e)}
                        ></textarea>
                      </div>
                    </div>
                  </label>
                </fieldset>
                <Button
                  endIcon={<SendIcon />}
                  fullWidth
                  className="custom-color-button"
                  sx={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "10px",
                  }}
                  type="submit"
                  variant="contained"
                >
                  Send Message
                </Button>
              </div>
              <div style={{ width: "50%" }}>
                <img src={require("./support.jpg")} style={{ width: "100%" }} />
              </div>
            </div>
          </form>
        </Box>
      </div>
    </Box>
  );
}

export default SupportForm;
